import {
  Account,
  Id,
  id,
  Identifiable,
  Planzone,
  Resource,
  user,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedResource, Linker } from "../linkers/types";

type Response = {
  _embedded: {
    resources: LinkedResource<Identifiable<Resource> & { userUuid: Id }>[];
  };
};

function getPlanzoneRole(httpClient: HttpClient, linker: Linker) {
  return (account: Identifiable<Account>, planzone: Identifiable<Planzone>) =>
    httpClient
      .sendHttpRequest<Response>({
        endpoint: `/resources/search/rsql?query=userContext.userUuid=="${account.uuid}"`,
        method: HttpMethods.GET,
      })
      .then(({ _embedded: { resources } }) =>
        resources[0] ? resources[0] : Promise.reject(),
      )
      .then(linker.linkResource)
      .then(({ role }) => (role ? { ...role, uuid: id } : Promise.reject()));
}

export { getPlanzoneRole };
